import * as actionTypes from './actionTypes';
import axios from '../../Axios/axios';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import UTF8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';

const FileDownload = require('js-file-download');


var SecurityManager = {
        salt: 'x6aOEWzbq6GWTFNdbyuo',
        username: localStorage['SecurityManager.username'],
        key: localStorage['SecurityManager.key'],
        ip: null,
        CreateUID: function(){
   
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c==='x' ? r :((r&0x3)|0x8)).toString(16);
            });
            return uuid;
        },
        generate: function (username, password) {
            
            var uuid = this.CreateUID();

            // Set the username.
            SecurityManager.username =username; // SecurityManager.username || username;

            // Set the key to a hash of the user's password + salt.
            SecurityManager.key = Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));//SecurityManager.key || Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));

            // Set the client IP address.
            SecurityManager.ip = "192.168.56.1";

            // Persist key pieces.
            if (SecurityManager.username) {
                localStorage['SecurityManager.username'] = SecurityManager.username;
                localStorage['SecurityManager.key'] = SecurityManager.key;
            }

            // Get the (C# compatible) ticks to use as a timestamp. http://stackoverflow.com/a/7968483/2596404
            var ticks = ((new Date().getTime() * 10000) + 621355968000000000);

            // Construct the hash body by concatenating the username, ip, and userAgent.
            var message = [SecurityManager.username, SecurityManager.ip, navigator.userAgent.replace(/ \.NET.+;/, ''), ticks].join(':');
             message = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');

            // Hash the body, using the key.
            var hash = HmacSHA256(message, SecurityManager.key);

            // Base64-encode the hash to get the resulting token.
            var token = Base64.stringify(hash);

            // var token = CryptoJS.enc.Base64.stringify(hash); ===== hashLeft = Convert.ToBase64String(hmac.Hash);
            // Include the username and timestamp on the end of the token, so the server can validate.
            // var tokenId = [SecurityManager.username, ticks].join(':');
            var tokenId = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');

            // Base64-encode the final resulting token.
            var tokenStr = UTF8.parse([token, tokenId].join(':'));
            var tokenfinal = Base64.stringify(tokenStr);
    

            //----
            // Voici la chaîne attendue :) :):) :):):):):):):):)::):):):):
            //----
            // dXoxZDJwSTBTL3R4dUZXVDhDV21aT1RKMDJ6a280MVZCeVpBMmFma0Q3ST06UFZTOjE5Mi4xNjguNTYuMTpkOTBiMjViZi0wNTFlLTQ3MzAtYjY4Yy02NmY2NzMwMDk5NmY6NjM3MTk0MzMwNTA2MTU2MTU3

            return tokenfinal;
    
        },
    
     

    
     
    
        
    
    };

export const loginTry = (obj, props) => {
    return (dispatch) => {
        console.log(localStorage,localStorage['AVAFINusername']);
        var tmpPassword = obj.ObjParamDto.MDP;


        var token = SecurityManager.generate(obj.ObjParamDto.IDE,obj.ObjParamDto.MDP);
        //obj.ObjParamDto.IDE ="";
        obj.ObjParamDto.MDP ="";
        obj.ObjParamDto.SessionIDE =token;
        obj.Session.Session.SESSION_ID=token;
        axios.ArcsAxios.post("WCFWindowsArcs/EmpGetUserByLoginAndPasswordSECURE", obj)
        .then(response => {
            if(response.data.USER !== ""){
                localStorage['AVAFINusername'] = obj.ObjParamDto.IDE;
                localStorage['AVAFINpassword'] = tmpPassword;
                var Num_Sitae = response.data.NUM_SITAE;
                
                obj.ObjParamDto.TP_NN= 107;
                obj.ObjParamDto.TP_NX= 0;
                obj.ObjParamDto.ARCS= Num_Sitae;
                dispatch(updateActiveMenu("Home"));
                dispatch(updateActiveSubMenu("Dashboard"));
                dispatch(updateActiveURI("/"));
                dispatch(loginReturn(true));
                dispatch(extractUserName(response.data.USER));
                axios.ArcsAxios.post("WCFWindowsArcs/PERLoad",obj)
                .then(response => {
                    dispatch(clientListing(response.data.EntitesNx));
                    dispatch(extractFiduciaire(response.data.WORDING));
                    obj.ObjParamsDto = {};
                    obj.ObjParamDto = null;
                    obj.ObjParamsDto.ARCS_DB = 110;   // SQL SERVER
                    obj.ObjParamsDto.ARCS_ENV = 107;  // PROD
                    obj.ObjParamsDto.SessionIDE =token;
                    axios.ArcsAxios.post("WCFWindowsArcs/REQ2ECLoad",obj)
                    .then(responseReq => {
                        var requetesRAW = responseReq.data;
                        dispatch(createMenu(responseReq.data));
                        obj.ObjParamsDto = {};
                        obj.ObjParamsDto.ARCS_TP_DBX = 110;  // LDB
                        obj.ObjParamsDto.ARCS_PER=Num_Sitae;
                        obj.ObjParamsDto.SessionIDE =token;
                        axios.ArcsAxios.post("WCFWindowsArcs/DBXECLoad",obj)
                        .then(responseECLoad => {
                            obj.ObjParamsDto = {};
                            // TODO CHECK IF ANY
                            obj.ObjParamsDto.LINK_DB = response.data.EntitesNx[0].WORDING;

                            //
                            //obj.ObjParamsDto.ARCS_TP_DBX = 110;//
                            obj.ObjParamsDto.ARCS_PER=Num_Sitae; 

                            //obj.ObjParamsDto.RecordFlag = "EC";
                            obj.ObjParamDto = {};
                            obj.ObjParamDto.SessionIDE = obj.Session.Session.SESSION_ID;
                            obj.ObjParamsDto.SessionIDE=obj.Session.Session.SESSION_ID;

                            axios.ArcsAxios.post("WCFWindowsArcs/VIEWECLoadInterne",obj)
                            .then(response => {
                                    var clientsName = response.data.filter(data => data.ARCS_REQ === 25 );
                                    var fullScope = response.data.filter(data => data.ARCS_REQ !== 25 );
                                    dispatch(clientListing(clientsName));
                                    dispatch(fullScopeData(fullScope));
                                    dispatch(formatData({requetes:requetesRAW,data:fullScope}));
                                    dispatch(onFullLoadData());
                                    axios.AvafinAxios.post("WCFWindowsAvaFin/AvaFinClose",obj.Session)
                                    .then(response => {
                                        console.log("Close");
                                    })
                                    .catch(error => {
                                        console.log("Error");
                                        console.log(error);
                                    })
                            })
                            .catch(error => {
                                console.log("Error");
                                console.log(error);
                            })
    
                        })
                        .catch(error => {
                            console.log("Error");
                            console.log(error);
                        })
                        dispatch(onLoadReturn(response,obj));
                    })
                    .catch(error => {
                        console.log("Error");
                        console.log(error);
                    })
                })
                .catch(error => {
                    console.log("Error");
                    console.log(error);
                })
            }else{
                dispatch(loginReturn(false));
            }
            
            })
            .catch(error => {
                dispatch(loginReturn(false));
                console.log("Error");
                console.log(obj);
                console.log(error);
            })
    }
};

export const logoutReturn =() =>{
    return (dispatch) => {
        dispatch(onFullLoadData());
        dispatch(onLogoutReturn());
    }
    
}

export const CreateUID =()=>{
   
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c==='x' ? r :((r&0x3)|0x8)).toString(16);
    });
    return uuid;
}



export const openSession = (props) => {
    var UID = CreateUID();
     var sessionReact = {
        Application : 'AvaFin', 
        CodeApplication : 6, 
        Session:{
            ACCEPT_ACTIVEXOBJECT:0, 
            ACCEPT_COOKIES:0, 
            ACCEPT_JAVASCRIPT:0, 
            AC_001:0, 
            BROWSER_NAME:'', 
            BROWSER_UPDATEINTERVAL:'', 
            BROWSER_UPDATES:'', 
            BROWSER_VERSION:'', 
            COMPUTER_IP:'192.168.56.1', 
            COMPUTER_OPERATINGSYSTEM:'Win32NT - Microsoft Windows NT 6.2.9200.0 - 6.2.9200.0 - ', 
            FLAG : 0, 
            IU:null, 
            LANGUAGE_SYSTEM:'fr-FR', 
            LANGUAGE_USER:'FR', 
            NSYS : 6, 
            RUNTIME_FW_NET:'4.0.30319.42000', 
            SCREEN_COLORDEPTH:'32', 
            SCREEN_RESOLUTION:'1920*1080', 
            SESSION_END : -62135596800000,                                              // 1899-12-30 00:00:00.000
            SESSION_ID : UID, 
            SESSION_START : Math.round((new Date()).getTime()),                         // Date 
            SESSION_TYPE : 61, 
            Status:0, 
            USERID_LOGICAL:'JHON DOE', 
            USERID_PHYSICAL:'', 
            USER_ENTREPRISE:'EMPTY', 
            USER_IDE:0, 
            USER_NAME:'', 
            USER_PSW:''}};

    return (dispatch) => {
        axios.AvafinAxios.post("WCFWindowsAvaFin/AvaFinOpen",sessionReact)
        .then(response => {
            dispatch(openSessionReturn(response,sessionReact));
            
        })
        .catch(error => {
            console.log("Error");
            console.log(error);
        })
    }
};

const openSessionReturn =(response,sessionReact) =>{
    return {
        type: actionTypes.OPEN_SESSION_RETURN,
        data: {sessionReact:sessionReact,response:response}
    }
}



const onLoadReturn =(response,sessionReact) =>{
    return {
        type: actionTypes.PER_LOAD_RETURN,
        data: {sessionReact:sessionReact,response:response}
    }
}


export const initialLoad =(props)=>{
    // Create list of loading assets (components), to load async
    let componentsToLoad = [
        {url:"api/ENDPOINT", name:"API",message:"API Success | ",error:"Error Message"},
    ]; 
    return (dispatch) => {
        componentsToLoad.forEach(function(component)
        {
            axios.get(component.url)
            .then(response => {
                console.log(response);
                //dispatch(addStatusLog(component.message + componentLoaded+"/"+componentsToLoad.length+" Assets ready",props));
            })
            .catch(error => {
                console.log(error);
                //dispatch(errorOnRequest(component.error));
            });
            
        });

    }
};


export const uploadFile = (type,url,obj)=>{
    var _responseType = ''; 
    switch(type){
        case "arrayBuffer":
            _responseType = 'arraybuffer';
            break;
        default:
            _responseType = '';
            break;
    }

    return (dispatch) =>{
        axios.post(url,obj,{
            headers: {
                'content-type': 'multipart/form-data'
            },
            responseType: _responseType
        }).then(response =>{
            FileDownload(response.data, 'FILENAME_'+new Date().getFullYear()+''+("0" + (new Date().getMonth() + 1)).slice(-2)+''+new Date().getDate()+'.txt');
        }).catch(error => {
            console.log(error);
        })
    }
};


export const postData = (type,url, obj,props,itemType) => {
    return (dispatch) =>{
        axios.post(url,obj).then(response =>{
            //dispatch return to update State
           
            console.log(response);
        }).catch(error => {
            console.log(error);
        })
    }
};


export const getData = (url, props, itemType) => {
    return (dispatch) => {
        axios.get(url)
        .then(response => {
            console.log(response);
            //dispatch(getDataSuccess(response.data,url,itemType));
        })
        .catch(error => {
            console.log(error);
        })
    }
};


export const putData = (url, obj, props,itemType) => {

    return (dispatch) => {
        axios.put(url, obj)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.log(error);
        })
    }
};


export const deleteData = (url, props,itemType) => {
    return (dispatch) => {
        axios.delete(url)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.log(error);
        })
    }
};

export const sortHeaderAction =(data)=>{
    return {
        type:actionTypes.SORT_HEADER,
        data:data
    }
}

export const sortHeaderActionByColumnId =(data)=>{
    return {
        type:actionTypes.SORT_HEADER_BY_COLUMN_ID,
        data:data
    }
}

export const formatData =(data)=>{
    return {
        type:actionTypes.ON_FORMATING_DATA,
        data:data
    }
}

export const changeClientActive =(data)=>{
    return {
        type:actionTypes.UPDATE_CLIENT_ACTIVE,
        data:data
    }

} 


export const togglePresentationMode = (data) =>{
    return {
        type: actionTypes.PRESENTATION_MODE,
        data: data
    }
}
export const toggleNightMode = (data) =>{
    return {
        type: actionTypes.NIGHT_MODE,
        data: data
    }
}

export const updateActiveMenu = (data) =>{
    return {
        type: actionTypes.UPDATE_ACTIVE_MENU,
        data: data
    }
}

export const updateActiveURI = (data) =>{
    return {
        type: actionTypes.UPDATE_ACTIVE_URI,
        data: data
    }
}

export const updateActiveData = (data) =>{
    return {
        type: actionTypes.UPDATE_ACTIVE_DATA,
        data: data
    }
}

export const updateActiveSubMenu = (data) =>{
    return {
        type: actionTypes.UPDATE_ACTIVE_SUBMENU,
        data: data
    }
}

export const loginReturn = (data) =>{
    return {
        type: actionTypes.LOGIN_RETURN,
        data: data
    }
}

export const onFullLoadData = (data) =>{
    return {
        type: actionTypes.CHANGE_FULL_LOADING,
        data: data
    }
}

export const clientListing = (data) =>{
    return {
        type: actionTypes.CLIENT_LISTING,
        data: data
    }
}

export const fullScopeData = (data) =>{
    return {
        type: actionTypes.GET_FULL_SCOPE,
        data: data
    }
}


export const extractUserName = (data) =>{
    return {
        type: actionTypes.EXTRACT_USERNAME,
        data: data
    }
}

export const extractFiduciaire = (data) =>{
    return {
        type: actionTypes.EXTRACT_FIDUCIAIRE,
        data: data
    }
}



export const onLogoutReturn = ()=>{
    return {
        type: actionTypes.LOGOUT,
        data: false
    }
}

export const getClientList = () =>{
    return {
        type:actionTypes.GETCLIENTLIST,
        data:null
    }
}

export const createMenu = (data) =>{
    return {
        type:actionTypes.CREATE_MENU,
        data:data
    }
}
